import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Flex } from 'styled-system/jsx';
import DownloadIcon from '@/common/assets/icons/download.svg?react';
import FilesIcon from '@/common/assets/icons/files.svg?react';
import { token } from 'styled-system/tokens';
import useDownloadDocument from '@/modules/FileDetail/hooks/useDownloadDocument';
import { createZipVehiclePicturesQueryOptions } from '@/modules/FileDetail/queries/documentation/createZip/createZipVehiclePictures/createZipVehiclePicturesQueryOptions';
import { downloadZipVehiclePicturesQueryOptions } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipVehiclePictures/downloadZipVehiclePicturesQueryOptions';
import { useParams } from 'react-router-dom';
import FileImageZipModal from '@/modules/FileDetail/components/documentation/modals/FileImageZipModal/FileImageZipModal';
import useModal from '@/common/hooks/useModal';

const FileImagesZip = () => {
  const { id } = useParams();
  const { createZip, isPending } = useDownloadDocument({
    createOption: createZipVehiclePicturesQueryOptions,
    downloadOption: downloadZipVehiclePicturesQueryOptions,
    downloadParams: { id: id! },
  });
  const { closeModal, open, openModal } = useModal();
  return (
    <>
      <CardButton
        title="تصاویر وسیله‌نقلیه"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            <DownloadIcon stroke={token('colors.purple-2')} />
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            openModal();
          },
        }}
        renderIcon={() => <FilesIcon />}
      />
      <FileImageZipModal
        closeModal={closeModal}
        open={open}
        isPending={isPending}
        downloadFunction={({ id, images_quality }) => {
          if (!id) return;
          createZip({ id, images_quality });
        }}
      />
    </>
  );
};

export default FileImagesZip;
